import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { GenericState } from 'src/app/_enums/generic-state.enum';

import { IconsModule } from '../../icons/icons.module';

@Component({
  selector: 'app-slide-in-modal',
  templateUrl: './slide-in-modal.component.html',
  styleUrls: ['./slide-in-modal.component.css'],
  standalone: true,
  imports: [CommonModule, IconsModule],
})
export class SlideInModalComponent {
  @Output()
  closed = new EventEmitter();

  @Input()
  size: 'md' | 'lg' | 'xl' = 'md';

  @Input()
  headerState: GenericState;

  /**
   * How many slide-ins this one may open above. Two at the same level tie on
   * z-index and fall back to DOM order, with the upper one's backdrop caught
   * beneath the lower one's panel; each level lifts both by a step, in the
   * stylesheet, through the `--layer` custom property.
   */
  @Input()
  layer = 0;

  left: string;

  widthString: string;

  @Input()
  set width(value: number) {
    if (value > 0 && value <= 100) {
      this.widthString = `${value}vw`;
      this.left = `${100 - value}vw`;
    } else {
      this.left = null;
      this.widthString = null;
    }
  }

  @ViewChild('modalRef')
  modalRef!: ElementRef;

  opened = false;

  openModal() {
    // Missing when a modal is opened straight from a route, before this view
    // has been created — and a view that new is already scrolled to the top.
    if (this.modalRef) {
      this.modalRef.nativeElement.scrollTop = 0;
    }
    this.opened = true;
  }

  closeModal(emitEvent = true) {
    this.opened = false;
    this.width = null;
    if (emitEvent) {
      this.closed.emit();
    }
  }
}
